import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '@env/environment';

interface ClarityFn {
  (...args: unknown[]): void;
  q?: unknown[][];
}

declare global {
  interface Window {
    clarity?: ClarityFn;
  }
}

const CLARITY_PROJECT_ID = 'y27bppwq2u';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private readonly router = inject(Router);

  private readonly excludedUrls = ['/login'];
  private hasInitialized = false;

  initialize(): void {
    // Clarity ne doit tourner qu'en production : pas de tracking des sessions de dev/test.
    if (!environment.production || this.hasInitialized) return;
    this.hasInitialized = true;

    this.loadScript();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => this.handleNavigation((event as NavigationEnd).urlAfterRedirects));

    this.handleNavigation(this.router.url);
  }

  private loadScript(): void {
    const clarityFn: ClarityFn = (...args) => {
      (clarityFn.q = clarityFn.q || []).push(args);
    };
    window.clarity = window.clarity || clarityFn;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
    document.head.appendChild(script);
  }

  private handleNavigation(url: string): void {
    const currentPath = url.split('?')[0];
    const isExcluded = this.excludedUrls.some((excludedUrl) => currentPath.startsWith(excludedUrl));

    if (isExcluded) {
      window.clarity?.('stop');
    } else {
      window.clarity?.('start');
    }
  }
}
